export default __webpack_public_path__ + "static/commmune-circle-7a02b8c302d892e7a0c83388ac471ade.svg";